import React, { useContext, useState } from "react";
import { Button } from "@mui/material";
import { managementSearchPanelBtnStyle } from "./AdminManagmentSearchPanel";
import { uploadMahnungCsv } from "../../api/admin-mahnwesen-api";
import { SnackBarContext } from "../../context/snackbar-context";

const AdminCsvUpload: React.FC<{ onImportCsv: () => Promise<void> }> = ({
  onImportCsv,
}) => {
  const snackBarCtx = useContext(SnackBarContext);

  const [uploading, setUploading] = useState(false);

  const handleSelectAndUpload = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    try {
      setUploading(true);
      await uploadMahnungCsv(selectedFile);
      snackBarCtx.openSnackbar("Upload erfolgreich !", "success");
      await onImportCsv();
    } catch (err) {
      snackBarCtx.openSnackbar(
        "Beim Upload ist ein Fehler aufgetreten !",
        "error"
      );
      console.error(err);
    } finally {
      setUploading(false);
      e.target.value = ""; // reset input for same file re-upload
    }
  };

  return (
    <label htmlFor="csv-upload">
      <input
        id="csv-upload"
        type="file"
        accept=".csv"
        onChange={handleSelectAndUpload}
        style={{ display: "none" }}
      />
      <Button
        variant="contained"
        component="span"
        sx={managementSearchPanelBtnStyle}
        disabled={uploading}
      >
        {uploading ? "Lädt hoch..." : "CSV importieren"}
      </Button>
    </label>
  );
};

export default AdminCsvUpload;
